// import { DatePicker, Form, Radio } from "antd";
// import { Select } from "antd";
// import { Input } from "antd";
// import { Col, Row } from "antd";
// import React, { FC } from "react";
// import { IFetchAllDetails } from "../../../../../interfaces/IPatient";

// type TreatmentNewProps = {
//   formattedConsultationType: Array<{ label: string; value: string }>;
//   govtHospitalList: any;
//   diagnosisList: any;
//   patientStore: IFetchAllDetails | null;
//   form: any;
//   portalData: any;
//   isApproved: boolean;
// };

// const TreatmentNew: FC<TreatmentNewProps> = (props) => {
//   const dateFormat = "DD-MM-YYYY HH:mm:ss";
//   const primaryDiagnosis = Form.useWatch("primaryDiagnosis", props?.form);

//   return (
//     <>
//       <div
//         style={{
//           textDecoration: "underline",
//           fontSize: "18px",
//           marginBottom: "6px",
//           fontWeight: "bold",
//         }}
//       >
//         Treatment Details
//       </div>
//       <Form
//         form={props?.form}
//         //   onFinish={handleSubmit}
//         labelAlign="left"
//         layout="vertical"
//         labelWrap
//         style={{ width: "100%", padding: "8px" }}
//       >
//         <Row gutter={[16, 16]}>
//           {props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
//           "CGHS" ? (
//             (props?.patientStore?.referralInfoResponse?.cghsReferralResponse
//               ?.id &&
//               props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
//                 "EMERGENCY") ||
//             ((props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
//               "IP" ||
//               props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
//                 "OP") &&
//               props?.patientStore?.patientResponse?.age < 70) ||
//             (props?.patientStore?.referralInfoResponse?.cghsReferralResponse
//               ?.id &&
//               props?.patientStore?.patientResponse?.age > 70) ||
//             props?.patientStore?.referralInfoResponse?.cghsReferralResponse
//               ?.id ? (
//               <Row gutter={[16, 16]}>
//                 <Col xs={24} sm={12} md={6} lg={6} xl={6}>
//                   <Form.Item
//                     label="IS REFERRAL TYPE?"
//                     name="referralType"
//                     style={{ color: "black" }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please select referral type",
//                       },
//                     ]}
//                   >
//                     <Radio.Group
//                       options={[
//                         { label: "MANUAL", value: "manual" },
//                         { label: "E-REFERRAL", value: "e-referral" },
//                       ]}
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//                   <Form.Item
//                     label="REFERRAL NO"
//                     name="referralNumber"
//                     style={{ color: "#575757" }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please input Referral No",
//                       },
//                     ]}
//                   >
//                     <Input
//                       placeholder="Please input Referral No"
//                       style={{ color: "black" }}
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                       autoComplete="off"
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//                   <Form.Item
//                     label="REFERRAL TYPE"
//                     name="consultationType"
//                     style={{ color: "#575757" }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please select REFERRAL TYPE",
//                       },
//                     ]}
//                   >
//                     <Select
//                       showSearch
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                       placeholder="Select a REFERRAL TYPE"
//                       options={props?.formattedConsultationType?.map(
//                         (option) => ({
//                           value: option?.value + "~" + option?.label,
//                           label: option?.label,
//                         })
//                       )}
//                       allowClear
//                       style={{ color: "black" }}
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//                   <Form.Item
//                     label="REFERRAL DATE"
//                     name="referralDate"
//                     style={{ color: "black" }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please input REFERRAL DATE",
//                       },
//                     ]}
//                   >
//                     <DatePicker
//                       style={{ width: "100%" }}
//                       format={dateFormat}
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//                   <Form.Item
//                     label="REFERRAL BY"
//                     name="referralBy"
//                     style={{ color: "#575757" }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please input Referral By",
//                       },
//                       {
//                         pattern: /^[a-zA-Z\s]*$/,
//                         message: "Only alphabets and spaces are allowed",
//                       },
//                     ]}
//                   >
//                     <Input
//                       placeholder="Please input Referral By"
//                       style={{ color: "black" }}
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                       autoComplete="off"
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={7} lg={7} xl={7}>
//                   <Form.Item
//                     label="WELLNESS CENTER NAME/GOVERNMENT HOSPITAL"
//                     name="govtHospital"
//                     style={{ color: "#575757" }}
//                     // rules={[
//                     //   {
//                     //     required: true,
//                     //     message:
//                     //       "Please select WELLNESS CENTER NAME/GOVERNMENT HOSPITAL",
//                     //   },
//                     // ]}
//                   >
//                     <Select
//                       showSearch
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                       placeholder="Select a WELLNESS CENTER NAME/GOVERNMENT HOSPITAL"
//                       options={props?.govtHospitalList?.map((option: any) => ({
//                         value:
//                           option?.govtHospitalCode +
//                           "~" +
//                           option?.govtHospitalName,
//                         label: option?.govtHospitalName,
//                       }))}
//                       allowClear
//                     />
//                   </Form.Item>
//                 </Col>

//                 <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//                   <Form.Item
//                     label="REMARKS"
//                     name="remarks"
//                     style={{ color: "#575757" }}
//                     //   rules={[
//                     //     {
//                     //       required: true,
//                     //       message: "Please input Remarks",
//                     //     },
//                     //   ]}
//                   >
//                     <Input
//                       placeholder="Please input Remarks"
//                       style={{ color: "black" }}
//                       disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                       autoComplete="off"
//                     />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             ) : (
//               <></>
//             )
//           ) : (
//             <></>
//           )}

//           <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: 0 }}>
//             <Form.Item
//               label="PRIMARY DIAGNOSIS"
//               name="primaryDiagnosis"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select Primary Diagnosis",
//                 },
//               ]}
//             >
//               <Select
//                 showSearch
//                 disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                 placeholder="Select a Primary Diagnosis"
//                 options={props?.diagnosisList?.map((option: any) => ({
//                   value:
//                     option?.primaryDiagnosisCode +
//                     "~" +
//                     option?.primaryDiagnosisName,
//                   label: option?.primaryDiagnosisName,
//                 }))}
//                 allowClear
//               />
//             </Form.Item>
//           </Col>

//           {primaryDiagnosis?.split("~")?.[1]?.toUpperCase() === "OTHER" ? (
//             <Col xs={24} sm={12} md={4} lg={4} xl={4}>
//               <Form.Item
//                 label="DIAGNOSIS DESCRIPTION"
//                 name="diagnosisDescription"
//                 style={{ color: "#575757" }}
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input Diagnosis Description",
//                   },
//                 ]}
//               >
//                 <Input
//                   placeholder="Please input Diagnosis Description"
//                   style={{ color: "black" }}
//                   disabled={props?.portalData?.casePreAuthCghs?.claimId}
//                 />
//               </Form.Item>
//             </Col>
//           ) : (
//             <></>
//           )}

//           <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: 0 }}>
//             <h3>Treatment Plan</h3>
//             <Form.Item
//               label="Speciality"
//               name="speciality"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input Speciality",
//                 },
//               ]}
//             ></Form.Item>

//             <Form.Item
//               label="ICHI Code"
//               name="ichiCode"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input ICHI Code",
//                 },
//               ]}
//             ></Form.Item>
//           </Col>

//           <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: 0 }}>
//             <h3>Investigations/Documents</h3>
//             <Form.Item
//               label="CGHS CARD"
//               name="cghsCard"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input CGHS CARD",
//                 },
//               ]}
//             ></Form.Item>

//             <Form.Item
//               label="Patient Photo"
//               name="patientPhoto"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input Patient Photo",
//                 },
//               ]}
//             ></Form.Item>
//           </Col>

//           <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: 0 }}>
//             <h3>Care Team Details</h3>
//             <Form.Item
//               label="OTHER"
//               name="other"
//               style={{ color: "#575757" }}
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input OTHER",
//                 },
//               ]}
//             ></Form.Item>
//           </Col>
//         </Row>
//       </Form>
//     </>
//   );
// };

// export default TreatmentNew;

import {
  DatePicker,
  Form,
  Radio,
  Button,
  Upload,
  message,
  Select,
  Input,
  Col,
  Row,
} from "antd";
import React, { FC, useMemo } from "react";
import { IFetchAllDetails } from "../../../../../interfaces/IPatient";

type TreatmentNewProps = {
  formattedConsultationType: Array<{ label: string; value: string }>;
  govtHospitalList: any;
  diagnosisList: any;
  patientStore: IFetchAllDetails | null;
  form: any;
  portalData: any;
  isApproved: boolean;
};

const sectionTitleStyle: React.CSSProperties = {
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "10px",
  marginTop: "14px",
  color: "#000", // Black headings
  borderBottom: "1px solid #d9d9d9",
  paddingBottom: "4px",
};

const TreatmentNew: FC<TreatmentNewProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const primaryDiagnosis = Form.useWatch("primaryDiagnosis", props?.form);
  const referralType = Form.useWatch("referralType", props?.form);
  const isDisabled =
    !!props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted;

  const schemeName =
    props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase?.() ||
    "";
  const isCghsOrCapf = useMemo(() => schemeName.includes("CGHS"), [schemeName]);

  const selectedDiagnosisLabel =
    typeof primaryDiagnosis === "string" && primaryDiagnosis?.includes("~")
      ? primaryDiagnosis.split("~")[1]
      : undefined;

  const handleSearchReferral = () =>
    message.info("Search referral flow to be integrated");
  const handleVerifyMobile = () =>
    message.info("OTP sent to the entered mobile number");

  return (
    <>
      {isCghsOrCapf && (
        <div
          // style={{
          //   fontSize: "18px",
          //   fontWeight: "bold",
          //   marginBottom: "16px",
          //   color: "#000", // Black main title
          //    textDecorationLine: "underline"
          // }}
          style={{
            textDecoration: "underline",
            fontSize: "18px",
            marginBottom: "6px",
            fontWeight: "bold",
          }}
        >
          Treatment Details
        </div>
      )}

      <Form
        form={props?.form}
        layout="vertical"
        labelAlign="left"
        style={{ width: "100%", padding: "8px" }}
      >
        <Row gutter={[16, 16]}>
          {isCghsOrCapf && (
            <>
              <Col span={24}>
                <div style={sectionTitleStyle}>Referral Details</div>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Referral Type"
                  name="referralType"
                  rules={[
                    {
                      required:
                        props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                          "EMERGENCY" ||
                        (props?.patientStore?.patientResponse?.age ?? 0) >= 70
                          ? false
                          : true,
                      message: "Please select referral type",
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { label: "Manual", value: "manual" },
                      { label: "e-Referral", value: "e-referral" },
                    ]}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Referral Number"
                  name="referralNumber"
                  rules={[
                    {
                      required:
                        props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                          "EMERGENCY" ||
                        (props?.patientStore?.patientResponse?.age ?? 0) >= 70
                          ? false
                          : true,
                      message: "Please input Referral Number",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Referral Number"
                    disabled={isDisabled}
                    // addonAfter={
                    //   referralType === "e-referral" ? (
                    //     <Button
                    //       type="link"
                    //       onClick={handleSearchReferral}
                    //       disabled={isDisabled}
                    //     >
                    //       SEARCH
                    //     </Button>
                    //   ) : null
                    // }
                  />
                </Form.Item>
              </Col>

              {referralType === "e-referral" ? (
                <></>
              ) : (
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Wellness Center/Govt Hospital"
                    name="govtHospital"
                  >
                    <Select
                      showSearch
                      disabled={isDisabled}
                      placeholder="Select Wellness Center/Govt Hospital"
                      options={props?.govtHospitalList?.map((option: any) => ({
                        value: `${option?.govtHospitalCode}~${option?.govtHospitalName}`,
                        label: option?.govtHospitalName,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              )}

              {referralType === "e-referral" ? (
                <></>
              ) : (
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Date of Referral"
                    name="referralDate"
                    rules={[
                      {
                        required:
                          props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                            "EMERGENCY" ||
                          (props?.patientStore?.patientResponse?.age ?? 0) >= 70
                            ? false
                            : true,
                        message: "Please input Date of Referral",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format={dateFormat}
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </Col>
              )}

              {referralType === "e-referral" ? (
                <></>
              ) : (
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Referral/Endorsement By"
                    name="referralBy"
                    rules={[
                      {
                        required:
                          props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                            "EMERGENCY" ||
                          (props?.patientStore?.patientResponse?.age ?? 0) >= 70
                            ? false
                            : true,
                        message: "Please input Referral/Endorsement by",
                      },
                      {
                        pattern: /^[a-zA-Z\s]*$/,
                        message: "Only alphabets and spaces allowed",
                      },
                    ]}
                  >
                    <Input placeholder="Enter name" disabled={isDisabled} />
                  </Form.Item>
                </Col>
              )}
              {referralType === "e-referral" ? (
                <></>
              ) : (
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Endorsement Hospital"
                    name="endorsementHospital"
                  >
                    <Input
                      placeholder="Enter Endorsement Hospital"
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Remarks" name="remarks">
                  <Input placeholder="Enter Remarks" disabled={isDisabled} />
                </Form.Item>
              </Col>

              {/* <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Mobile Number"
                  name="mobileNumber"
                  rules={[
                    { required: true, message: "Please enter Mobile Number" },
                    {
                      pattern: /^[6-9]\d{9}$/,
                      message: "Enter valid 10-digit number",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Mobile Number"
                    maxLength={10}
                    disabled={isDisabled}
                    addonAfter={
                      <Button
                        type="link"
                        onClick={handleVerifyMobile}
                        disabled={isDisabled}
                      >
                        VERIFY
                      </Button>
                    }
                  />
                </Form.Item>
              </Col> */}

              {/* <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Enter OTP"
                  name="otp"
                  rules={[
                    { required: true, message: "Please enter OTP" },
                    { len: 6, message: "OTP must be 6 digits" },
                  ]}
                >
                  <Input
                    placeholder="Enter OTP"
                    maxLength={6}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col> */}

              {/* <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="Upload Document (Referral Letter)"
                  name="referralLetterUpload"
                >
                  <Upload beforeUpload={() => false} disabled={isDisabled}>
                    <Button disabled={isDisabled}>
                      Upload Referral Letter
                    </Button>
                  </Upload>
                </Form.Item>
              </Col> */}
            </>
          )}

          {/* Diagnosis Section */}
          {/* <Col span={24}>
            <div style={sectionTitleStyle}>Diagnosis</div>
          </Col> */}

          {/* <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="PRIMARY DIAGNOSIS"
              name="primaryDiagnosis"
              rules={[{ required: true, message: "Please select Diagnosis" }]}
            >
              <Select
                showSearch
                disabled={isDisabled}
                placeholder="Search Diagnosis"
                options={props?.diagnosisList?.map((option: any) => ({
                  value: `${option?.primaryDiagnosisCode}~${option?.primaryDiagnosisName}`,
                  label: option?.primaryDiagnosisName,
                }))}
                allowClear
              />
            </Form.Item>
          </Col>

          {primaryDiagnosis?.split("~")?.[1]?.toUpperCase() === "OTHER" && (
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                label="Diagnosis Description"
                name="diagnosisDescription"
                rules={[
                  {
                    required: true,
                    message: "Please input Diagnosis Description",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Diagnosis Description"
                  disabled={isDisabled}
                />
              </Form.Item>
            </Col>
          )} */}

          {/* Care Team */}
          {/* <Col span={24}>
            <div style={sectionTitleStyle}>Care Team Details</div>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="Doctor's Name"
              name="doctorName"
              rules={[
                { required: true, message: "Please enter Doctor's Name" },
              ]}
            >
              <Input placeholder="Enter Doctor's Name" disabled={isDisabled} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="Registration ID / HPR ID"
              name="doctorRegistrationId"
            >
              <Input
                placeholder="Enter Registration/HPR ID"
                disabled={isDisabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Qualification" name="doctorQualification">
              <Select
                disabled={isDisabled}
                mode="multiple"
                allowClear
                placeholder="Select Qualification"
                options={[
                  { label: "M.B.B.S.", value: "MBBS" },
                  { label: "M.D.", value: "MD" },
                  { label: "M.Ch", value: "MCh" },
                  { label: "D.M.", value: "DM" },
                  { label: "M.S.", value: "MS" },
                  { label: "DNB", value: "DNB" },
                  { label: "MDS", value: "MDS" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="Contact No."
              name="doctorContact"
              rules={[
                {
                  pattern: /^[6-9]\d{9}$/,
                  message: "Enter a valid 10-digit number",
                },
              ]}
            >
              <Input
                placeholder="Enter Contact No."
                maxLength={10}
                disabled={isDisabled}
              />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </>
  );
};

export default TreatmentNew;
